<template>
  <div class="raster-thumbnail"
    :class="{selected: sliceCurrentIndex === image.index}"
    @click="$emit('selectSlice', image.index)"
    :style="{height: (rasterThumbSize && rasterThumbSize.h || 0) + 15 + 'px'}">
    <image-not-found v-if="imgNotFound" />
    <pixel-shaded-canvas
      :img="img"
      :octColorSettings="octColorSettings"
      :canvasSize="rasterThumbSize"
      :imgSize="rasterThumbSize"
      :dontUseWebgl="true"/>
    <v-progress-circular v-if="isLoading" class="escalon-absolute-center" indeterminate />
  </div>
</template>

<script>
import pixelShadedCanvas from "../../../canvas/components/PixelShadedCanvas";
import imageNotFound from "../../misc/ImageNotFound";
export default {
  name: "rasterThumbnail",
  components: { pixelShadedCanvas, imageNotFound },
  props: ["image", "index", "octDataLoading", "sliceCurrentIndex", "octColorSettings", "rasterThumbSize"],
  computed: {
    imgNotFound(){
      return !!(this.image && this.image.imgNotFound);
    },
    img() {
      return this.image && this.image.imgHtmlObject;
    },
    imgIsLoading() {
      return this.image && (this.image.imgIsLoading || this.image.imgIsQueued);
    },
    isLoading() {
      return this.octDataLoading || this.imgIsLoading;
    }
  }
};
</script>

<style lang="scss" scoped>
.raster-thumbnail {
  position: relative;
  height: 200px;
  border: 1px solid $color-grey;

  &:not(:last-child) {
    margin-bottom: 15px;
  }

  &:hover, &.selected {
    background-color: $color-grey;
    cursor: pointer;
  }
}
</style>

